import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Outlet, PathRouteProps, useLocation } from 'react-router-dom';
import Header from '../blocks/Header';
import AppContext, { token_config } from '../AppContext';
import { getServerTime } from './axiosInstance';

interface ProtectedRouteProps extends PathRouteProps {
  authenticationPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  authenticationPath = '/login',
  ...routeProps
}) => {
  const location = useLocation();
  const [isPageCanLoad, setIsPageCanLoad] = useState(false);
  const { userInfo } = useContext(AppContext);

  useEffect(() => {
    if (userInfo) {
      fetchServerTime();
    }
  }, [userInfo, location.key]);

  const fetchServerTime = async () => {
    try {
      await getServerTime();
      setIsPageCanLoad(true);
    } catch (error: any) {
      console.log(error);
    }
  }

  const isLoggedIn = localStorage.getItem(token_config.ACCESS_TOKEN) !== null;
  if (!isLoggedIn) {
    return <Navigate to={authenticationPath} replace />;
  }

  return (
    <>
      {isPageCanLoad && (
        <>
          <Header />
          <Outlet />
        </>
      )}
    </>
  );
};

export { ProtectedRoute };
